import { $api } from '@service/RequestService';
import { useMutation, useQueryClient } from 'react-query';

import { clientConstants } from '..';

export const useForceAttachClientConfigDelete = () => {
  const qc = useQueryClient();

  return useMutation(
    async (data: { configId?: number }) => {
      const res = await $api.delete(`/v1/force-attach-client/config/${data.configId}`);

      return res?.data;
    },
    {
      onSuccess: async () => {
        await qc.invalidateQueries([clientConstants.queryKeys.FORCE_ATTACH_CLIENT_CONFIG_ALL]);
      }
    }
  );
};
